import React from "react";
import styled from 'styled-components';
import gifpic from '../pictures/gif.jpg';

class GIF extends React.Component {
render(){
const WORKCOVER = styled.div`
    width: 100%;
    height: 100%;
`;

const TITLE = styled.h1`
    margin: 0;
    padding-top: calc(30px + 8vw);
    padding-bottom: 3vh;
    text-align: center;
    color: black;
`;

const BOX = styled.div`
`;

const IMG = styled.img`
    width: 35%;
    height: 100%;
    display: block;
    margin: 0 auto;
    `;

const CONTENT = styled.div`
    padding: 3em;
`;

const TECH = styled.div`
    color: black;
    font-size:calc(10px + 0.4vw)
`;

const BUTTONS = styled.div`
    display: flex;
    justify-content: space-around;
    text-align:center;
    vertical-align: middle;
`;
const BUTTON = styled.a`
    width: calc(40px + 4vw);
    height: calc(20px + 2.5vw);
    line-height: calc(20px + 2.5vw);
    margin: 1em;
    padding: 0.23em 0.5em;
    font-size:calc(10px + 0.4vw)
    font-weight: bold;
    color: white;
    border-style: none;
    border-radius: 3px;
    text-decoration: none;
    background-color: #0F4137;
`;
return(
<div>
<WORKCOVER>
    <TITLE>GIF検索</TITLE>
    <BOX>
        <IMG src= {gifpic} alt=""/>
        <CONTENT>
            <TECH>
            使用技術：<br/>
            HTML/CSS/JavaScript/React.js/Redux/axios<br/><br/>
            詳細：<br/>
            好きな単語を入力するとGIF画像を検索することができます。<br/>
            APIを使ったデータのやり取りにはaxiosを使用しました。<br/>
            Udemyを見て作ったものです（デモおよびGitHub掲載にあたりコース製作者様には許可を得ております）。
            </TECH>
            <BUTTONS>
                <BUTTON href="https://yukiamakawa.github.io/GIF_API/" target="_blank">
                    デモ
                </BUTTON>
                <BUTTON href = "https://github.com/YukiAmakawa/GIF_API_code" target="_blank">
                    GitHub
                </BUTTON>
            </BUTTONS>
        </CONTENT>
    </BOX>
</WORKCOVER>

</div>
)}}

export default GIF;


// WEBPACK FOOTER //
// ./src/components/Gif.js